<script>
import paymentState from "@/utils/states/payment";
import copyToClipboard from "@/utils/functions/copyToClipboard";

export default {
  props: {
    payment: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      state: null
    };
  },

  methods: {
    copy() {
      copyToClipboard("line_code");
    },

    setState() {
      this.state = paymentState.getState(this.payment.status);
    }
  },
  mounted() {
    this.setState();
  },
  watch: {
    payment() {
      this.setState();
    }
  }
};
</script>

<template>
  <section class="pb-10 mb-10">
    <img class="mr-10" src="/static/icon-boleto.svg" height="45px" />

    <div class="data">
      <div class="header">
        <b>Pagamento por&nbsp;Boleto</b>
        <div class="status">
          <div v-if="state" class="label" :class="'bg-'+state.color">{{state.name}}</div>
          <a
            v-if="payment.funding_instrument.url_print"
            :href="payment.funding_instrument.url_print"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-small bg-purple-outline"
          >
            <img src="/static/icon-download.svg" height="10px" />&nbsp;download
          </a>
        </div>
      </div>

      <div v-if="payment.funding_instrument.line_code" class="line-code">
        <div class="mr-5" id="line_code">{{payment.funding_instrument.line_code}}</div>

        <button @click="copy" class="btn btn-small bg-purple-outline">
          <img class="mr-5" src="/static/icon-copy.svg" height="10px" />copiar
        </button>
      </div>

      <div v-else class="line-code">Não foi gerada uma linha digitável para este pagamento.</div>
    </div>
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.line-code {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.header {
  display: flex;
  align-items: center;
}

.header div {
  margin: 0 5px;
}

.status {
  display: flex;
}

.btn-small {
  padding: 4px 8px;
}

@media (max-width: 673px) {
  section,
  .header,
  .line-code {
    align-items: center;
    flex-direction: column;
    text-align: center;
  }

  .status {
    margin: 5px 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/PaymentHistory/Boleto.vue